export default __webpack_public_path__ + "static/media/plusIcon.3d364914.svg";